// /**
//  * SessionChallengeListener.js
//  *
//  * Mount this ONCE inside your authenticated layout (homepage.js or App.js).
//  * It subscribes to /topic/session/{mySessionId} and shows a modal when
//  * someone tries to log in with the same credentials.
//  *
//  * Place it in homepage.js return:
//  *   <SessionChallengeListener />
//  */

// import React, { useEffect, useRef, useState } from "react";
// import { Modal, Button, Typography, message } from "antd";
// import { WarningOutlined } from "@ant-design/icons";
// import { Client } from "@stomp/stompjs";
// import SockJS from "sockjs-client";
// import Cookies from "js-cookie";
// import { useNavigate } from "react-router-dom";
// import api from "../../../BasicComponent/Service/api";

// const { Text } = Typography;

// const wsUrl = process.env.REACT_APP_API?.replace("/api", "") || "https://localhost:8081";
// const BASE   = process.env.REACT_APP_API + "/write-control/execution";

// const SessionChallengeListener = () => {
//   const navigate  = useNavigate();
//   const clientRef = useRef(null);
//   const [challengeVisible, setChallengeVisible] = useState(false);
//   const [challengeInfo, setChallengeInfo]       = useState(null);  // { challengeSessionId, email }
//   const [responding, setResponding]             = useState(false);

//   useEffect(() => {
//     const sessionId = Cookies.get("SESSION_ID");
//     if (!sessionId) return;

//     const client = new Client({
//       webSocketFactory: () => new SockJS(`${wsUrl}/api/ws`),
//       reconnectDelay: 5000,
//       onConnect: () => {
//         client.subscribe(`/topic/session/${sessionId}`, (msg) => {
//           const payload = JSON.parse(msg.body);

//           if (payload.type === "LOGIN_CHALLENGE") {
//             setChallengeInfo(payload);
//             setChallengeVisible(true);
//           }

//           if (payload.type === "FORCE_LOGOUT") {
//             // This session was accepted to be replaced
//             message.warning("You have been logged out because a new session was accepted.");
//             Cookies.remove("AUTH_TOKEN");
//             Cookies.remove("REFRESH_TOKEN");
//             Cookies.remove("user_details");
//             Cookies.remove("SESSION_ID");
//             navigate("/login", { replace: true });
//           }
//         });
//       },
//     });

//     client.activate();
//     clientRef.current = client;

//     return () => clientRef.current?.deactivate();
//   }, [navigate]);

//   // ── Session heartbeat — tells backend this tab is still alive ──────────────
//   // Backend auto-expires sessions with no heartbeat after 30 minutes.
//   // Send heartbeat every 2 minutes.
//   useEffect(() => {
//     const sessionId = Cookies.get("SESSION_ID");
//     if (!sessionId) return;

//     const sendHeartbeat = () => {
//       const sid = Cookies.get("SESSION_ID");
//       if (!sid) return;
//       api.post(`${BASE}/session/${sid}/heartbeat`).catch(() => {});
//     };

//     sendHeartbeat(); // immediately on mount
//     const interval = setInterval(sendHeartbeat, 2 * 60 * 1000); // every 2 min
//     return () => clearInterval(interval);
//   }, []);

//   const handleAccept = async () => {
//     setResponding(true);
//     try {
//       const sessionId = Cookies.get("SESSION_ID");
//       await api.post(`${BASE}/session/${sessionId}/accept`);
//       setChallengeVisible(false);
//       // FORCE_LOGOUT will arrive via WebSocket and handle the redirect
//     } catch (err) {
//       message.error("Failed to accept: " + (err?.response?.data?.message || err.message));
//     } finally {
//       setResponding(false);
//     }
//   };

//   const handleReject = async () => {
//     setResponding(true);
//     try {
//       const sessionId = Cookies.get("SESSION_ID");
//       await api.post(`${BASE}/session/${sessionId}/reject`);
//       setChallengeVisible(false);
//       message.success("New login request rejected.");
//     } catch (err) {
//       message.error("Failed to reject: " + (err?.response?.data?.message || err.message));
//     } finally {
//       setResponding(false);
//     }
//   };

//   return (
//     <Modal
//       open={challengeVisible}
//       footer={null}
//       closable={false}
//       centered
//       width={440}
//     >
//       <div style={{ textAlign: "center", padding: "8px 0" }}>
//         <WarningOutlined style={{ fontSize: 48, color: "#ff4d4f", marginBottom: 16 }} />
//         <h3 style={{ margin: "0 0 8px" }}>Someone wants to log in</h3>
//         <p style={{ color: "#666", marginBottom: 8 }}>
//           A login attempt was made using your credentials from another device.
//         </p>
//         {challengeInfo?.email && (
//           <Text type="secondary" style={{ fontSize: 12 }}>
//             Account: <strong>{challengeInfo.email}</strong>
//           </Text>
//         )}
//         <p style={{ color: "#999", fontSize: 13, margin: "16px 0" }}>
//           If you <strong>Accept</strong>, your current session will close and the other device will log in.
//           <br />
//           If you <strong>Reject</strong>, the other device will not be allowed in.
//         </p>

//         <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
//           <Button
//             danger
//             size="large"
//             loading={responding}
//             onClick={handleReject}
//             style={{ flex: 1 }}
//           >
//             Reject
//           </Button>
//           <Button
//             type="primary"
//             size="large"
//             loading={responding}
//             onClick={handleAccept}
//             style={{ flex: 1 }}
//           >
//             Accept
//           </Button>
//         </div>
//       </div>
//     </Modal>
//   );
// };

// export default SessionChallengeListener;

/**
 * SessionChallengeListener.js
 *
 * Mount this ONCE inside your authenticated layout (homepage.js or App.js).
 * It subscribes to /topic/session/{mySessionId} and shows a modal when
 * someone tries to log in with the same credentials.
 *
 * Place it in homepage.js return:
 *   <SessionChallengeListener />
 */

// /**
//  * SessionChallengeListener.js
//  *
//  * Mount this ONCE inside your authenticated layout (homepage.js or App.js).
//  * It subscribes to /topic/session/{mySessionId} and shows a modal when
//  * someone tries to log in with the same credentials.
//  *
//  * Place it in homepage.js return:
//  *   <SessionChallengeListener />
//  */

// import React, { useEffect, useRef, useState } from "react";
// import { Modal, Button, Typography, message } from "antd";
// import { WarningOutlined } from "@ant-design/icons";
// import { Client } from "@stomp/stompjs";
// import SockJS from "sockjs-client";
// import Cookies from "js-cookie";
// import { useNavigate } from "react-router-dom";
// import api from "../../../BasicComponent/Service/api";

// const { Text } = Typography;

// const wsUrl = process.env.REACT_APP_API?.replace("/api", "") || "https://localhost:8081";
// const BASE   = process.env.REACT_APP_API + "/write-control/execution";

// const SessionChallengeListener = () => {
//   const navigate  = useNavigate();
//   const clientRef = useRef(null);
//   const [challengeVisible, setChallengeVisible] = useState(false);
//   const [challengeInfo, setChallengeInfo]       = useState(null);  // { challengeSessionId, email }
//   const [responding, setResponding]             = useState(false);

//   useEffect(() => {
//     const sessionId = Cookies.get("SESSION_ID");
//     if (!sessionId) return;

//     const client = new Client({
//       webSocketFactory: () => new SockJS(`${wsUrl}/api/ws`),
//       reconnectDelay: 5000,
//       onConnect: () => {
//         client.subscribe(`/topic/session/${sessionId}`, (msg) => {
//           const payload = JSON.parse(msg.body);

//           if (payload.type === "LOGIN_CHALLENGE") {
//             setChallengeInfo(payload);
//             setChallengeVisible(true);
//           }

//           if (payload.type === "FORCE_LOGOUT") {
//             // This session was accepted to be replaced
//             message.warning("You have been logged out because a new session was accepted.");
//             Cookies.remove("AUTH_TOKEN");
//             Cookies.remove("REFRESH_TOKEN");
//             Cookies.remove("user_details");
//             Cookies.remove("SESSION_ID");
//             navigate("/login", { replace: true });
//           }
//         });
//       },
//     });

//     client.activate();
//     clientRef.current = client;

//     return () => clientRef.current?.deactivate();
//   }, [navigate]);

//   // ── Session heartbeat — tells backend this tab is still alive ──────────────
//   // Backend auto-expires sessions with no heartbeat after 30 minutes.
//   // Send heartbeat every 2 minutes.
//   useEffect(() => {
//     const sessionId = Cookies.get("SESSION_ID");
//     if (!sessionId) return;

//     const sendHeartbeat = () => {
//       const sid = Cookies.get("SESSION_ID");
//       if (!sid) return;
//       api.post(`${BASE}/session/${sid}/heartbeat`).catch(() => {});
//     };

//     sendHeartbeat(); // immediately on mount
//     const interval = setInterval(sendHeartbeat, 2 * 60 * 1000); // every 2 min
//     return () => clearInterval(interval);
//   }, []);

//   const handleAccept = async () => {
//     setResponding(true);
//     try {
//       const sessionId = Cookies.get("SESSION_ID");
//       await api.post(`${BASE}/session/${sessionId}/accept`);
//       setChallengeVisible(false);
//       // FORCE_LOGOUT will arrive via WebSocket and handle the redirect
//     } catch (err) {
//       message.error("Failed to accept: " + (err?.response?.data?.message || err.message));
//     } finally {
//       setResponding(false);
//     }
//   };

//   const handleReject = async () => {
//     setResponding(true);
//     try {
//       const sessionId = Cookies.get("SESSION_ID");
//       await api.post(`${BASE}/session/${sessionId}/reject`);
//       setChallengeVisible(false);
//       message.success("New login request rejected.");
//     } catch (err) {
//       message.error("Failed to reject: " + (err?.response?.data?.message || err.message));
//     } finally {
//       setResponding(false);
//     }
//   };

//   return (
//     <Modal
//       open={challengeVisible}
//       footer={null}
//       closable={false}
//       centered
//       width={440}
//     >
//       <div style={{ textAlign: "center", padding: "8px 0" }}>
//         <WarningOutlined style={{ fontSize: 48, color: "#ff4d4f", marginBottom: 16 }} />
//         <h3 style={{ margin: "0 0 8px" }}>Someone wants to log in</h3>
//         <p style={{ color: "#666", marginBottom: 8 }}>
//           A login attempt was made using your credentials from another device.
//         </p>
//         {challengeInfo?.email && (
//           <Text type="secondary" style={{ fontSize: 12 }}>
//             Account: <strong>{challengeInfo.email}</strong>
//           </Text>
//         )}
//         <p style={{ color: "#999", fontSize: 13, margin: "16px 0" }}>
//           If you <strong>Accept</strong>, your current session will close and the other device will log in.
//           <br />
//           If you <strong>Reject</strong>, the other device will not be allowed in.
//         </p>

//         <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
//           <Button
//             danger
//             size="large"
//             loading={responding}
//             onClick={handleReject}
//             style={{ flex: 1 }}
//           >
//             Reject
//           </Button>
//           <Button
//             type="primary"
//             size="large"
//             loading={responding}
//             onClick={handleAccept}
//             style={{ flex: 1 }}
//           >
//             Accept
//           </Button>
//         </div>
//       </div>
//     </Modal>
//   );
// };

// export default SessionChallengeListener;

/**
 * SessionChallengeListener.js
 *
 * Mount this ONCE inside your authenticated layout (homepage.js or App.js).
 * It subscribes to /topic/session/{mySessionId} and shows a modal when
 * someone tries to log in with the same credentials.
 *
 * Place it in homepage.js return:
 *   <SessionChallengeListener />
 */

import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Typography, message } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { acceptSession, rejectSession, sessionHeartbeat } from "../../AssetMonitoringSystem/module/writecontrole/service/Writecontrol";

const { Text } = Typography;

const wsUrl = process.env.REACT_APP_API?.replace("/api", "");
const SessionChallengeListener = () => {
  const navigate  = useNavigate();
  const clientRef = useRef(null);
  const [challengeVisible, setChallengeVisible] = useState(false);
  const [challengeInfo, setChallengeInfo]       = useState(null);  // { challengeSessionId, email }
  const [responding, setResponding]             = useState(false);

  useEffect(() => {
    const sessionId = Cookies.get("SESSION_ID");
    if (!sessionId) return;

    const client = new Client({
      webSocketFactory: () => new SockJS(`${wsUrl}/api/ws`),
      reconnectDelay: 5000,
      onConnect: () => {
        client.subscribe(`/topic/session/${sessionId}`, (msg) => {
          const payload = JSON.parse(msg.body);

          if (payload.type === "LOGIN_CHALLENGE") {
            setChallengeInfo(payload);
            setChallengeVisible(true);
          }

          if (payload.type === "FORCE_LOGOUT") {
            // This session was accepted to be replaced
            message.warning("You have been logged out because a new session was accepted.");
            Cookies.remove("AUTH_TOKEN");
            Cookies.remove("REFRESH_TOKEN");
            Cookies.remove("user_details");
            Cookies.remove("SESSION_ID");
            navigate("/login", { replace: true });
          }
        });
      },
    });

    client.activate();
    clientRef.current = client;

    return () => clientRef.current?.deactivate();
  }, [navigate]);

  // ── Session heartbeat — tells backend this tab is still alive ──────────────
  // Backend auto-expires sessions with no heartbeat after 30 minutes.
  // Send heartbeat every 2 minutes.
  useEffect(() => {
    const sessionId = Cookies.get("SESSION_ID");
    if (!sessionId) return;

    const sendHeartbeat = () => {
      const sid = Cookies.get("SESSION_ID");
      if (!sid) return;
      sessionHeartbeat(sid).catch(() => {});
    };

    sendHeartbeat(); // immediately on mount
    const interval = setInterval(sendHeartbeat, 2 * 60 * 1000); // every 2 min
    return () => clearInterval(interval);
  }, []);

  const handleAccept = async () => {
    setResponding(true);
    try {
      const sessionId = Cookies.get("SESSION_ID");
      await acceptSession(sessionId);
      setChallengeVisible(false);
      // FORCE_LOGOUT will arrive via WebSocket and handle the redirect
    } catch (err) {
      message.error("Failed to accept: " + (err?.response?.data?.message || err.message));
    } finally {
      setResponding(false);
    }
  };

  const handleReject = async () => {
    setResponding(true);
    try {
      const sessionId = Cookies.get("SESSION_ID");
      await rejectSession(sessionId);
      setChallengeVisible(false);
      message.success("New login request rejected.");
    } catch (err) {
      message.error("Failed to reject: " + (err?.response?.data?.message || err.message));
    } finally {
      setResponding(false);
    }
  };

  return (
    <Modal
      open={challengeVisible}
      footer={null}
      closable={false}
      centered
      width={440}
    >
      <div style={{ textAlign: "center", padding: "8px 0" }}>
        <WarningOutlined style={{ fontSize: 48, color: "#ff4d4f", marginBottom: 16 }} />
        <h3 style={{ margin: "0 0 8px" }}>Someone wants to log in</h3>
        <p style={{ color: "#666", marginBottom: 8 }}>
          A login attempt was made using your credentials from another device.
        </p>
        {challengeInfo?.email && (
          <Text type="secondary" style={{ fontSize: 12 }}>
            Account: <strong>{challengeInfo.email}</strong>
          </Text>
        )}
        <p style={{ color: "#999", fontSize: 13, margin: "16px 0" }}>
          If you <strong>Accept</strong>, your current session will close and the other device will log in.
          <br />
          If you <strong>Reject</strong>, the other device will not be allowed in.
        </p>

        <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
          <Button
            danger
            size="large"
            loading={responding}
            onClick={handleReject}
            style={{ flex: 1 }}
          >
            Reject
          </Button>
          <Button
            type="primary"
            size="large"
            loading={responding}
            onClick={handleAccept}
            style={{ flex: 1 }}
          >
            Accept
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SessionChallengeListener;